<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <div class="profile_sec">
                        <div class="profile_tab" id="profile_tab">
                            <div class="row" style="margin: 0 auto">
                                <div class="col-md-4 col-lg-3">
                                    <div class="card_gridTwo mb-10 profile_section" style="padding: 25px">
                                        <div class="user_profile_img" *ngIf="UserData?.profileImage">
                                            <img [src]="UserData.profileImage" alt="user img" />
                                        </div>
                                        <div class="user_profile_img" *ngIf="!UserData?.profileImage">
                                            <!-- <ngx-avatars
                                                name="{{ UserData?.profileContact?.firstName }} {{ UserData?.profileContact?.lastName }} {{ i }}"
                                                class="avatar"
                                                size="150"
                                                initialsSize="3"
                                                bgColor="#ffcc01"
                                                fgColor="#010101"
                                            ></ngx-avatars> -->
                                            <div
                                                class="custom-avatar avatar"
                                                [ngStyle]="{
                                                    width: '150px',
                                                    height: '150px',
                                                    backgroundColor: '#ffcc01',
                                                    color: '#010101',
                                                    fontSize: '50px',
                                                }"
                                            >
                                                {{ getInitials(UserData?.profileContact?.firstName + ' ' + UserData?.profileContact?.lastName + ' ' + i) }}
                                            </div>
                                        </div>
                                        <h4>
                                            {{ UserData?.profileContact?.firstName }} {{ UserData?.profileContact?.lastName }}
                                            <span>{{ UserData.securityRoles[0]?.securityRole?.name }}</span>
                                        </h4>
                                    </div>
                                    <div class="card_gridTwo mb-10">
                                        <h4 class="notification_title">{{ 'PROFILE_PAGE.TABS.AVAILABLE_INSTANCES' | transloco }}</h4>
                                        <div class="avilable_notification">
                                            <ul *ngFor="let instance of instances">
                                                <li>
                                                    <a href="javascript:void(0)"
                                                        ><img *ngIf="instance.logo" [src]="instance?.logo" />
                                                        <!-- <ngx-avatars
                                                            *ngIf="!instance.logo"
                                                            [name]="instance.name"
                                                            initialsSize="3"
                                                            class="avatar"
                                                            size="40"
                                                            bgColor="#ffcc01"
                                                            fgColor="#010101"
                                                        ></ngx-avatars> -->
                                                        <div
                                                            *ngIf="!instance.logo"
                                                            class="custom-avatar avatar"
                                                            [ngStyle]="{
                                                                width: '40px',
                                                                height: '40px',
                                                                backgroundColor: '#ffcc01',
                                                                color: '#010101',
                                                                fontSize: '16px',
                                                            }"
                                                        >
                                                            {{ getInitials(instance.name) }}
                                                        </div>
                                                    </a>
                                                    {{ instance?.name }}
                                                    <span *ngIf="instance?.notes; else assetType"> {{ instance?.notes }} </span>
                                                    <ng-template #assetType>
                                                        <span class="assetType"> {{ instance.instanceAssetType.name }}</span>
                                                    </ng-template>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8 col-lg-9">
                                    <div class="card_gridTwo card_grid_height">
                                        <mat-tab-group
                                            class="tab-wrapper"
                                            [(selectedIndex)]="generalTabIndex"
                                            #tabGroup
                                            (selectedTabChange)="onTabChange($event)"
                                        >
                                            <mat-tab label="{{ 'PROFILE_PAGE.TABS.PESRSONAL' | transloco }}" [aria-label]="0" *ngIf="isPersonalTabVisible">
                                                <app-user-personal-details
                                                    [form]="editProfileForm"
                                                    [generalTabIndex]="generalTabIndex"
                                                ></app-user-personal-details>
                                            </mat-tab>
                                            <mat-tab
                                                label="{{ 'PROFILE_PAGE.TABS.EMAIL_NOTIFICATIONS' | transloco }}"
                                                [aria-label]="1"
                                                *ngIf="isEmailNotificationVisible"
                                            >
                                                <app-user-email-notification-details
                                                    [form]="editProfileForm"
                                                    *ngIf="isEmailNotificationVisible"
                                                ></app-user-email-notification-details>
                                            </mat-tab>
                                            <mat-tab label="{{ 'PROFILE_PAGE.TABS.COMMUNICATION' | transloco }}" [aria-label]="2" *ngIf="isCommunicationTab">
                                                <app-communications
                                                    [profileForm]="editProfileForm"
                                                    [profileSettingType]="'Communication'"
                                                    [generalTabIndex]="generalTabIndex"
                                                ></app-communications>
                                            </mat-tab>
                                        </mat-tab-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
